var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedicalAndHealthCharities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Insurance-Hands--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Insurance Hands Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.88 11A1.12 1.12 0 0 0 20 9.88V6.12A1.12 1.12 0 0 0 18.88 5H15.5a0.5 0.5 0 0 1 -0.5 -0.5V1.12A1.12 1.12 0 0 0 13.88 0h-3.76A1.12 1.12 0 0 0 9 1.12V4.5a0.5 0.5 0 0 1 -0.5 0.5H5.12A1.12 1.12 0 0 0 4 6.12v3.76A1.12 1.12 0 0 0 5.12 11H8.5a0.5 0.5 0 0 1 0.5 0.5v3.38A1.12 1.12 0 0 0 10.12 16h3.76A1.12 1.12 0 0 0 15 14.88V11.5a0.5 0.5 0 0 1 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87 16.53a1.38 1.38 0 1 0 -2.25 1.59l0.78 1.08a0.5 0.5 0 0 1 -0.1 0.7 0.51 0.51 0 0 1 -0.7 -0.1l-1.1 -1.47a2.53 2.53 0 0 1 -0.5 -1.5V12.5a1.5 1.5 0 0 0 -3 0v5.67a5 5 0 0 0 1.1 3.12l2 2.52a0.49 0.49 0 0 0 0.4 0.19H8a0.5 0.5 0 0 0 0.5 -0.5v-3.14a5 5 0 0 0 -0.93 -2.77Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11a1.5 1.5 0 0 0 -1.5 1.5v4.33a2.53 2.53 0 0 1 -0.5 1.5l-1.1 1.47a0.51 0.51 0 0 1 -0.4 0.2 0.49 0.49 0 0 1 -0.3 -0.1 0.5 0.5 0 0 1 -0.1 -0.7l0.78 -1.08a1.39 1.39 0 0 0 0.24 -1.12 1.37 1.37 0 0 0 -0.7 -0.91 1.39 1.39 0 0 0 -1.79 0.45l-0.7 1.06a5 5 0 0 0 -0.93 2.77v3.13a0.5 0.5 0 0 0 0.5 0.5h4.5a0.49 0.49 0 0 0 0.39 -0.19l2 -2.52A5 5 0 0 0 24 18.17V12.5a1.5 1.5 0 0 0 -1.5 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedicalAndHealthCharities);
export default ForwardRef;